export function useTeamUpSessionStorage(key, defaultValue, options) {
  return useTeamUpStorage(key, defaultValue, { ...options, storageProvider: sessionStorage })
}
